import { render } from "./AllPatientsTable.vue?vue&type=template&id=076dad72&scoped=true"
import script from "./AllPatientsTable.vue?vue&type=script&lang=js"
export * from "./AllPatientsTable.vue?vue&type=script&lang=js"

import "./AllPatientsTable.vue?vue&type=style&index=0&id=076dad72&lang=css"
import "./AllPatientsTable.vue?vue&type=style&index=1&id=076dad72&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076dad72"]])

export default __exports__